import type { ThemeOptions } from '@mui/material';

const lightTheme: ThemeOptions = {
  palette: {
    mode: 'light',
    primary: {
      main: '#2B5BFC',
      dark: '#0032C8',
      light: '#95ADFD',
      contrastText: '#FFFFFF',
    },
    secondary: {
      main: '#050D26',
      dark: '#050D26',
      light: '#050D26',
      contrastText: '#FFF',
    },
    other: {
      main: '#EAEAF2',
      dark: '#EAEAF2',
      light: '#050D26',
      contrastText: '#050D26',
    },
    text: {
      primary: '#050D26',
      secondary: '#7F869E',
      disabled: '#B3B9CC',
    },
    success: {
      main: '#02BC9C',
      dark: '#008B6E',
      light: '#E6F8F5',
      contrastText: '#FFFFFF',
    },
    info: {
      main: '#2196F3',
      dark: '#0069C0',
      light: '#E9F4FE',
      contrastText: '#FFFFFF',
    },
    warning: {
      main: '#FF8A65',
      dark: '#C75B39',
      light: '#FFF3F0',
      contrastText: '#FFFFFF',
    },
    error: {
      main: '#F47373',
      dark: '#BD4248',
      light: '#FEF1F1',
      contrastText: '#FFFFFF',
    },
    background: {
      default: '#FFFFFF',
      secondary: '#F6F7FB',
      header: '#000',
    },
    action: {
      active: '#0000008A',
      hover: '#0000000A',
      selected: '#00000014',
      disabled: '#FFF',
      disabledBackground: '#C1CCED',
      focus: '#0000001F',
    },
    colors: {
      pink: { main: '#F06292' },
      purple: { main: '#BA68C8', light: 'rgba(186, 104, 200, 0.15)' },
      deepPurple: { main: '#9575CD' },
      indigo: { main: '#7986CB' },
      blue: { main: '#64B5F6', light: '#e0f1fd' },
      orange: { main: '#FFB74D', light: '#FFF9ED' },
      deepOrange: { main: '#FF8A65' },
      gray: { main: '#7F869E' },
      green: { main: '#72CB38', light: '#e9f7e1' },
      skyBlue: { main: '#2CC8D7', light: '#def7fa' },

      rose: { main: '#be123c', light: '#ffe4e6' },
      red: { main: '#b91c1c', light: '#fee2e2' },
      cyan: { main: '#0e7490', light: '#cffafe' },
      emerald: { main: '#047857', light: '#dcfce7' },
      fuchsia: { main: '#a21caf', light: '#fae8ff' },
      lime: { main: '#2CC8D7', light: '#ecfccb' },
      sky: { main: '#0369a1', light: '#e0f2fe' },
      teal: { main: '#0f766e', light: '#ccfbf1' },
      lavendust: { main: '#0f766e', light: '#ccfbf1' },
    },
    divider: '#EAEAF2',
  },
  typography: {
    fontFamily: "'Inter', sans-serif",
    h1: {
      fontSize: '1.5rem',
      fontWeight: 600,
    },
    h2: {
      fontSize: '1rem',
      lineHeight: 1.25,
      fontWeight: 600,
    },
    h3: {
      fontSize: '0.875rem',
      fontWeight: 600,
    },
    button: {
      fontSize: '0.875rem',
      lineHeight: '1.125rem',
      fontWeight: 600,
    },
    body1: {
      fontSize: '0.875rem',
      lineHeight: '1.125rem',
      fontWeight: 400,
    },
    caption: {
      fontSize: '0.75rem',
      lineHeight: '1rem',
      fontWeight: 500,
    },
    caption2: {
      fontSize: '0.675rem',
      lineHeight: '1rem',
      fontWeight: 500,
    },
  },
};

export default lightTheme;
